import React, { useCallback, useEffect, useMemo, useState } from "react";

import { useDispatch } from "react-redux";

import { useReduxSelector } from "@hooks/useReduxSelector";
import { documentStorageRHActions } from "@store/actions";

import FileBrowser, { Icons } from "@components/fileManager/src/index";
import DotLoader from "@components/tailwindComponents/DotLoader";

import {
  getCreateFiles,
  getRenamedFiles,
  onDeleteDocStorage
} from "@helpers/_functions";
import { DocumentStorage } from "@services/all.services";

import { getDocumentFileComparator } from "../sortFiles";

function SharedDocumentsRH(props) {
  const { employeeId, enterpriseSide, readOnly, isReadOnly } = props;
  const readOnlyMode = readOnly || isReadOnly;

  const reduxDispatch = useDispatch();
  const [files, setFiles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [orderType, setOrderType] = useState("nameUp");

  const dataFiles = useReduxSelector(
    ({ enterpriseEmployeData }) => enterpriseEmployeData.filesRH
  );
  const userConnected = useReduxSelector(({ userConnected }) => userConnected);
  const fileComparator = useMemo(
    () => getDocumentFileComparator(orderType),
    [orderType]
  );

  useEffect(() => {
    let active = true;
    setIsLoading(true);
    const load = async () => {
      try {
        await reduxDispatch(documentStorageRHActions.loadData(employeeId));
      } finally {
        if (active) setIsLoading(false);
      }
    };
    load();
    return () => { active = false; };
  }, [employeeId, reduxDispatch]);

  useEffect(() => {
    const currentList = dataFiles.employeId === employeeId ? dataFiles.list : [];
    const normalizedFiles = currentList.map((file) => ({
      ...file,
      modified: file.modified || 0
    }));

    setFiles(normalizedFiles);
  }, [dataFiles.list , dataFiles.employeId, employeeId]);

  const handleCreateFolder = useCallback(
    (key) => {
      const arrayName = key.split("/"),
        employer = employeeId,
        dataFolder = {
          key: key,
          originalName: arrayName[arrayName.length - 2],
          wasabiName: arrayName[arrayName.length - 2],
          type: "folder",
          isReadWrite: true,
          isVisible: false,
          employerId: employer,
          docType: "documentRH",
          entrepriseId: localStorage.getItem("enterpriseId"),
          size: 0
        };
      setFiles((prevstate) => [...prevstate, dataFolder]);

      return false;
    },
    [employeeId]
  );

  const handleCreateFiles = useCallback(
    (newFiles, prefix) => {
      const tempFiles = getCreateFiles(newFiles, prefix, files);
      setFiles(tempFiles);
    },
    [files]
  );

  const handleRenameFileOrFolder = useCallback(
    (oldKey, newKey) => {
      const { tempFiles, data_files } = getRenamedFiles(oldKey, newKey, files);

      DocumentStorage.updateById(data_files).catch(console.error);
      setFiles(tempFiles);
    },
    [files]
  );

  const handleDeleteFileOrFolder = useCallback(
    (key) => {
      const tempFiles = onDeleteDocStorage(key, files);
      setFiles(tempFiles);
    },
    [files]
  );

  const handleSortClick = useCallback((column) => {
    const up = `${column}Up`;
    const down = `${column}Down`;
    setOrderType((prevOrder) => (prevOrder === up ? down : up));
  }, []);

  const sortByNameFiles = useCallback(
    () => handleSortClick("name"),
    [handleSortClick]
  );
  const onSortDateModification = useCallback(
    () => handleSortClick("dateModified"),
    [handleSortClick]
  );

  if (enterpriseSide && isLoading) {
    return (
      <div className="arh-h-[40dvh]">
        <DotLoader size="small" />
      </div>
    );
  }

  return (
    <div className="container_documents arh-px-12 arh-pb-8">
      {/* @ts-ignore */}
      <FileBrowser
        isOnFileEmploye={Boolean(readOnly)}
        files={files}
        fileComparator={fileComparator}
        icons={Icons.FontAwesome(4)}
        Employer={employeeId}
        currentUser={userConnected}
        onCreateFolder={handleCreateFolder}
        onCreateFiles={handleCreateFiles}
        onMoveFolder={handleRenameFileOrFolder}
        onMoveFile={handleRenameFileOrFolder}
        onRenameFolder={handleRenameFileOrFolder}
        onRenameFile={handleRenameFileOrFolder}
        onDeleteFolder={handleDeleteFileOrFolder}
        onDeleteFile={handleDeleteFileOrFolder}
        docType="documentRH"
        isReadOnly={readOnlyMode}
        onDownloadFile={(items) => {
          console.log("downloadFile", items);
        }}
        sortByNameFiles={sortByNameFiles}
        onSortDateModification={onSortDateModification}
      />
    </div>
  );
}

export default React.memo(SharedDocumentsRH);
